import type { OctFlash2026MarketTier } from '../utils/get-oct-flash-2026-variant';
import { getOctFlash2026MarketTier } from '../utils/get-oct-flash-2026-variant';

export type OctFlash2026Variant = 'g1' | 'g2';

export const OCT_FLASH_2026_CTA_LABEL = 'Save now';
export const OCT_FLASH_2026_EYEBROW_LABEL = 'ENDS SOON';
export const OCT_FLASH_2026_CTA_COLOR = '#C35000';

export const OCT_FLASH_2026_CHECKOUT_HREF: Record<OctFlash2026MarketTier, string> = {
  full: '/checkout/individual/4month/credit-card',
  low: '/checkout/individual/annually/credit-card',
};

const PATTERN = '/images/promotions/oct-flash-2026/flash-sale-pattern.webp';
const HOMEPAGE_PATTERN_MOBILE = '/images/promotions/oct-flash-2026/homepage-bg-mobile.webp';
const EXPERIENCE_PATTERN = '/images/promotions/oct-flash-2026/experience-pattern.webp';
const STAMP_DESKTOP = '/images/promotions/oct-flash-2026/50-percent-off-desktop.webp';
const STAMP_MOBILE = '/images/promotions/oct-flash-2026/50-percent-off-mobile.webp';

const SHARED_VISUAL = {
  backgroundGradient: 'linear-gradient(109deg, #130701 0%, #773101 100%)',
  borderColor: '#C35000',
  eyebrowColor: '#E8C4A0',
  patternBlendMode: 'overlay',
  homepagePatternOpacity: { base: 0.55, md: 0.5 },
  catalogPatternOpacity: 0.6,
  subtitleColor: '#F3D9C4',
  homepagePatternDesktop: PATTERN,
  homepagePatternMobile: HOMEPAGE_PATTERN_MOBILE,
  homepagePatternMobileObjectPosition: 'center',
  experienceBackgroundGradient: 'linear-gradient(59deg, #120600 0%, #763000 94%)',
  experiencePattern: EXPERIENCE_PATTERN,
  catalogPatternDesktop: PATTERN,
  catalogPatternMobile: PATTERN,
} as const;

type OctFlash2026VariantConfig = {
  backgroundGradient: string;
  borderColor: string;
  eyebrowColor: string;
  patternBlendMode: 'overlay';
  homepagePatternOpacity: { base: number; md: number };
  catalogPatternOpacity: number;
  subtitleColor: string;
  headline: string;
  catalogHeadline: string;
  experienceHeadline: string;
  homepageSubtitle: string;
  catalogSubtitle: string;
  experienceSubtitle: string;
  homepagePatternDesktop: string;
  homepagePatternMobile: string;
  homepagePatternMobileObjectPosition: string;
  homepageStampDesktop?: string;
  homepageStampMobile?: string;
  homepageStampOffsetRightDesktop?: number;
  homepageStampSizeDesktop?: { height: number; width: number };
  homepageStampSizeMobile?: { height: number; width: number };
  experienceBackgroundGradient: string;
  experiencePattern: string;
  experienceStampDesktop?: string;
  experienceStampMobile?: string;
  catalogPatternDesktop: string;
  catalogPatternMobile: string;
};

export const OCT_FLASH_2026_VARIANTS: Record<OctFlash2026Variant, OctFlash2026VariantConfig> = {
  g1: {
    ...SHARED_VISUAL,
    headline: 'Flash sale for a limited time only',
    catalogHeadline: '50% OFF all programs',
    experienceHeadline: 'Flash sale',
    homepageSubtitle: "Build future-ready AI & tech skills with hands-on learning for what's next.",
    catalogSubtitle: 'Learn the AI & tech skills employers want.',
    experienceSubtitle: 'Build practical AI & tech skills for less.',
    homepageStampDesktop: STAMP_DESKTOP,
    homepageStampMobile: STAMP_MOBILE,
    homepageStampOffsetRightDesktop: 126,
    homepageStampSizeDesktop: { height: 164, width: 266 },
    homepageStampSizeMobile: { height: 115, width: 186 },
    experienceStampDesktop: STAMP_DESKTOP,
    experienceStampMobile: STAMP_MOBILE,
  },
  g2: {
    ...SHARED_VISUAL,
    headline: 'Flash sale for a limited time only',
    catalogHeadline: 'Flash sale',
    experienceHeadline: 'Flash sale',
    homepageSubtitle: "Build future-ready AI & tech skills with hands-on learning for what's next.",
    catalogSubtitle: 'Learn the AI & tech skills employers want.',
    experienceSubtitle: 'Build practical AI & tech skills for less.',
  },
};

export function getOctFlash2026CheckoutHref(variant: OctFlash2026Variant, promoCode?: string | null): string {
  const href = OCT_FLASH_2026_CHECKOUT_HREF[getOctFlash2026MarketTier(variant)];
  if (!promoCode) {
    return href;
  }
  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}coupon=${encodeURIComponent(promoCode)}`;
}
